/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconTextCaption = createReactComponent("text-caption", "IconTextCaption", [
  ["path", { d: "M4 15h16", key: "svg-0" }],
  [
    "path",
    {
      d: "M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z",
      key: "svg-1"
    }
  ],
  ["path", { d: "M4 20h12", key: "svg-2" }]
]);

export { IconTextCaption as default };
//# sourceMappingURL=IconTextCaption.js.map
